import { Flex } from '@mantine/core'

import { ActionPlanTable } from '@/modules/actionPlan/pages/components/ActionPlanTable/ActionPlanTable'
import { Recommendations } from '@/modules/actionPlan/pages/components/Recommendations/Recommendations'
import { SavedSummary } from '@/modules/actionPlan/pages/components/SavedSummary/SavedSummary'

import { TransactionSyncNotice } from '@/components/@Shared/TransactionSyncNotice/TransactionSyncNotice'
import { Insights } from '@/components/Insights/Insights'

import { page as InsightPage } from '@/__generated__/requests'

export function ActionPlanShell() {
  return (
    <>
      <TransactionSyncNotice mb={24} />

      <Flex
        direction={{
          base: 'column',
          sm: 'row',
        }}
        gap={16}
        justify="center"
        mb={24}
        wrap="wrap"
      >
        <SavedSummary />

        <Insights page={InsightPage.ACTION_PLAN} />
      </Flex>

      <Recommendations />

      <ActionPlanTable />
    </>
  )
}
